/**
 * Created by Vladislav on 03.06.2025.
 */

const SpaceRaceMissionLogic = function (mission) {
    cleverapps.EventEmitter.call(this);
    this.mission = mission;

    if (!mission.result && mission.result !== 0) {
        mission.result = 0;
    }
    if (!mission.details.stage && mission.details.stage !== 0) {
        mission.details.stage = 0;
    }
    if (!mission.details.started && mission.details.started !== 0) {
        mission.details.started = 0;
    }

    if (this.mission.isRunning()) {
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.mission.details.stage}`, once: true });
    }
};

SpaceRaceMissionLogic.prototype = Object.create(cleverapps.EventEmitter.prototype);
SpaceRaceMissionLogic.prototype.constructor = SpaceRaceMissionLogic;

SpaceRaceMissionLogic.prototype.setProgress = function (progress) {
    if (this.mission.result !== progress) {
        this.mission.setResult(progress, this.mission.details);
    }
};

SpaceRaceMissionLogic.prototype.logResultChange = function (delta) {
    if (delta > 0) {
        this.mission.logEvent(Mission.EVENTS.MISSION_POINTS_DAU, { once: true });
    }
};

SpaceRaceMissionLogic.prototype.setStage = function (stage) {
    if (this.mission.details.stage !== stage) {
        this.mission.setResult(this.mission.result, { ...this.mission.details, stage });
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${stage}` });
    }
};

SpaceRaceMissionLogic.prototype.setStarted = function (started) {
    if (this.mission.details.started !== started) {
        this.mission.setResult(this.mission.result, { ...this.mission.details, started });
    }
};

SpaceRaceMissionLogic.prototype.incProgress = function () {
    if (this.mission.result < this.giveStageInfo().target) {
        this.setProgress(this.mission.result + 1);
        this.mission.logEvent(Mission.EVENTS.MISSION_POINTS, { value: 1 });
        this.onUpdateMission(1);
        this.mission.updateCompetitionResults();

        cleverapps.metrics.logEvent(cleverapps.EVENTS.SPACE_RACE_INC_PROGRESS);
    }
};

SpaceRaceMissionLogic.prototype.giveStageInfo = function () {
    return this.mission.stages[this.getStage()];
};

SpaceRaceMissionLogic.prototype.resetProgress = function () {
    this.setProgress(0);

    this.mission.updateCompetitionResults();
};

SpaceRaceMissionLogic.prototype.isAttentionRequired = function () {
    if (this.mission.runningCompetition && this.mission.runningCompetition.hasPlaceChanged()) {
        return true;
    }

    return !this.isUnlocked();
};

SpaceRaceMissionLogic.prototype.finishRace = function () {
    const outcome = this.mission.runningCompetition.getOutcome();

    const reward = this.mission.getPrize();
    const place = 3 - this.getStage();

    if (place === 1 && outcome === Competition.OUTCOME_VICTORY) {
        this.mission.logEvent(Mission.EVENTS.MISSION_FINISH, { once: true });
    }

    cleverapps.focusManager.display({
        focus: "SpaceRaceFinished",
        stack: true,
        actions: [
            (f) => {
                if (outcome === Competition.OUTCOME_VICTORY) {
                    this.moveNextStage();
                } else {
                    this.stopStage();
                }

                f();
            },

            (f) => {
                if (!reward) {
                    f();
                    return;
                }

                new RewardWindow(reward, {
                    event: this.mission.name,
                    toBubbleStack: true
                });

                cleverapps.focusManager.onceNoWindowsListener = f;

                const rewardEventTime = this.mission.isCompleted() ? this.mission.finishTime() - 1 : undefined;
                this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, {
                    reward,
                    itemId: `${place}`,
                    event: rewardEventTime
                });
                this.mission.logDailyReward(place);
            },

            (f) => {
                if (this.mission.isRunning()) {
                    cleverapps.focusManager.hideAllControls();

                    const StartWindow = this.mission.startWindow;

                    new StartWindow(this.mission);

                    this.mission.skipStartWindow();

                    cleverapps.focusManager.onceNoWindowsListener = f;
                } else {
                    f();
                }
            }
        ]
    });
};

SpaceRaceMissionLogic.prototype.isUnlocked = function () {
    return Boolean(this.mission.details.started);
};

SpaceRaceMissionLogic.prototype.isRunning = function () {
    return this.isUnlocked() && this.mission.runningCompetition.getOutcome() === Competition.OUTCOME_NONE;
};

SpaceRaceMissionLogic.prototype.startStage = function () {
    this.setStarted(Date.now());
    this.mission.updateCompetition(true);
    this.updateIcon();
    cleverapps.missionManager.trigger("startStage", this.mission);
};

SpaceRaceMissionLogic.prototype.onUpdateCompetition = function () {
    this.mission.runningCompetition.on("outcome", () => {
        this.mission.stopCompetition();
    });
};

SpaceRaceMissionLogic.prototype.onUpdateMission = function (amount) {
    if (amount > 0) {
        this.trigger("updateResult");
        if (this.wantToShowNewState()) {
            cleverapps.missionManager.trigger("wantToShowNewState", this.mission);
        }
    }
};

SpaceRaceMissionLogic.prototype.stopStage = function () {
    this.setProgress(0);
    this.setStarted(0);

    this.mission.stopCompetition();
    this.mission.clearCompetition();

    this.updateIcon();
    cleverapps.missionManager.trigger("stopStage", this.mission);
};

SpaceRaceMissionLogic.prototype.updateIcon = function () {
    this.mission.updateMissionIcon();
    this.trigger("updateStatus");
};

SpaceRaceMissionLogic.prototype.moveNextStage = function () {
    this.stopStage();

    this.mission.logEvent(Mission.EVENTS.MISSION_PROGRESS, { index: this.getStage() });
    this.mission.logEvent(Mission.EVENTS.MISSION_PROGRESS_DAU, { once: true });

    this.setStage(this.mission.details.stage + 1);
};

SpaceRaceMissionLogic.prototype.getStage = function () {
    return Math.min(this.mission.details.stage, this.mission.stages.length - 1);
};

SpaceRaceMissionLogic.prototype.getStageNumber = function () {
    return this.mission.details.stage + 1;
};

SpaceRaceMissionLogic.prototype.getView = function () {
    if (!this.isUnlocked()) {
        return SpaceRaceStartWindow;
    }

    return SpaceRaceWindow;
};

SpaceRaceMissionLogic.prototype.getFinishWindow = function () {
    if (!this.isUnlocked()) {
        return;
    }

    return SpaceRaceWindow;
};

SpaceRaceMissionLogic.prototype.getCompetitionOptions = function () {
    return {
        ...this.mission.competition,
        ...this.giveStageInfo(),
        start: this.mission.details.started,
        oneWinner: this.mission.oneWinner
    };
};

SpaceRaceMissionLogic.prototype.receiveReward = function () {
    return undefined;
};

SpaceRaceMissionLogic.prototype.canRemove = function () {
    return !this.isUnlocked() || !this.mission.getPrize();
};

SpaceRaceMissionLogic.prototype.canRemoveSilently = function () {
    const outcome = this.mission.runningCompetition && this.mission.runningCompetition.getOutcome();
    return outcome !== Competition.OUTCOME_VICTORY;
};

SpaceRaceMissionLogic.prototype.wantToShowNewState = function () {
    const outcome = this.mission.runningCompetition && this.mission.runningCompetition.getOutcome();
    return typeof outcome !== "undefined";
};

SpaceRaceMissionLogic.prototype.getOrderRewards = function () {
    if (!this.isUnlocked()) {
        return;
    }

    return {
        missionType: this.mission.type,
        amount: 1
    };
};

SpaceRaceMissionLogic.prototype.calcStatusInfo = function () {
    const amount = this.mission.result;
    const { target } = this.giveStageInfo();

    return {
        text: this.isUnlocked() ? `%% ${amount}/${target}` : Messages.get("SideBarPlace.Start"),
        sidebarTitle: this.isUnlocked() ? undefined : Messages.get("SpaceRace.inactive"),
        disabled: !this.isUnlocked(),
        icons: {
            "%%": this.mission.getIcon()
        },
        progressBar: this.isUnlocked() && { amount, target }
    };
};
